document.addEventListener('DOMContentLoaded', function() {
  // SKU on PDP based on Variant select 
  const variantSku_container = document.getElementById("product-variant-sku");
  document.addEventListener('variant-sku', (event) => {
    const skuValue = event.detail.sku;
    console.log('skuValue: ', skuValue);
    variantSku_container.innerHTML = skuValue.split('_')[1];
 });

  // contact form status into Enquire Button on PDP
  const urlParams = new URLSearchParams(window.location.search);
  const svgString = `<svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-success' viewBox='0 0 13 13'>
                          <path d='M6.5 12.35C9.73087 12.35 12.35 9.73086 12.35 6.5C12.35 3.26913 9.73087 0.65 6.5 0.65C3.26913 0.65 0.65 3.26913 0.65 6.5C0.65 9.73086 3.26913 12.35 6.5 12.35Z' fill='#428445' stroke='white' stroke-width='0.7'></path>
                          <path d='M5.53271 8.66357L9.25213 4.68197' stroke='white'></path>
                          <path d='M4.10645 6.7688L6.13766 8.62553' stroke='white'></path>
                      </svg>`;


  if(urlParams.size > 0 && urlParams.get('contact_posted') === 'true') {
  document.getElementById('formStatusContainer').innerHTML = svgString + "Thanks for contacting us. We'll get back to you as soon as possible.";
  }

});
  